module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 cell"
  }, [_c('h1', [_vm._v("Your profile")]), _vm._v(" "), _c('p', [_vm._v("You're logged in as " + _vm._s(_vm.user.email) + ".")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38dc3a19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Profile.vue
// module id = 70
// module chunks = 0